import { getJwtAuthToken } from '@/core/domain/model/jwtAuthToken';

const refreshUseCase = (repository) => async () => {
    try {
        const jwtAuthToken = getJwtAuthToken()
        const newJwtAuthToken = await repository(jwtAuthToken)
        localStorage.setItem('auth', JSON.stringify(newJwtAuthToken))
        return true
    } catch (error) {
        return false
    }
}

export default refreshUseCase